module.exports = function () {
  return new Worker(__webpack_public_path__ + "7ac486371f6b1fcd6ae2.worker.js");
};